import {Pipe, PipeTransform} from '@angular/core';
import {createFlashAnimationValue, FlashAnimationValue, updateFlashAnimationValue} from './flash-animation';

const CLASS_UP = '-up';
const CLASS_DOWN = '-down';

@Pipe({
    name: 'valueChangeAnimation',
    pure: true
})
export class ValueChangeAnimationPipe implements PipeTransform {

    public state: FlashAnimationValue = createFlashAnimationValue();

    private prevValue: any;

    private isFirst: boolean = true;

    public transform(value: any, includeUpDown: boolean = false, doReset: boolean = false): string {
        if (doReset) {
            if (!this.isFirst) {
                this.isFirst = true;
                this.prevValue = undefined;
                this.state = this.state.state ? createFlashAnimationValue() : this.state;
            }
        } else {
            if (!this.isFirst) {
                const isUpdated = value !== this.prevValue;

                const addCls = includeUpDown
                    ? (value > this.prevValue ? CLASS_UP : CLASS_DOWN)
                    : undefined;

                this.state = updateFlashAnimationValue(this.state, isUpdated, addCls);
            } else {
                this.isFirst = false;
            }
        }

        this.prevValue = value;

        return this.state.className;
    }

}
